<template>
    <ValidationProvider :name="label" :rules="rules" v-slot="{ errors, required }" :mode="validationmode" :vid="computedVid" slim>
        <div class="migrol-form__input-wrapper" :class="[cssclass, { 'migrol-form__input-wrapper--error' : errors.length > 0 }]" :style="computedStyle">
            <label :for="$id('input')" class="migrol-form__input-label" v-if="label && showLabel">{{label}}{{(required ? '*' : '')}}</label>
            <div class="migrol-form__input-container">
                <input class="migrol-form__input-field" :class="{ 'migrol-form__input-field--prefixed' : prefix, 'migrol-form__input-field--postfixed' : postfix }" :id="$id('input')" :placeholder="label" v-model="innerValue" v-on="inputListeners" :type="inputType" :autocomplete="autocomplete" :name="name" :disabled="isDisabled" @keypress="checkSapCharacters($event)" :maxlength="maxlength > 0 ? maxlength : false">
                <div class="migrol-form__input-prefix" v-if="prefix">{{prefix}}</div>
                <div class="migrol-form__input-postfix" v-if="postfix">{{postfix}}</div>
                <slot></slot>
            </div>
            <div class="migrol-form__error-message">{{errors[0]}}</div>
        </div>
    </ValidationProvider>
</template>

<script>
    import { isNullOrUndefined } from 'util';
    import { allowCharacter } from '../utils/utilities'
    import { ValidationProvider } from 'VeeValidate';

    export default {
        inheritAttrs: false,
        props: {
            label: {
            },
            showLabel: {
                type: Boolean,
                default: true
            },
            flex: {
                type: String,
                default: '1',
                required: false
            },
            prefix: {
                type: String,
                default: null,
                required: false
            },
            postfix: {
                type: String,
                default: null,
                required: false
            },
            value: {
                default: ''
            },
            rules: {
                type: [Object, String],
                default: null,
                required: false
            },
            validationmode: {
                type: [String, Function],
                required: false
            },
            vid: {
                type: String,
                default: ''
            },
            cssclass: {
                type: [Object, String],
                default: null,
                required: false
            },
            name: {
                type: String,
                default: null,
                required: false
            },
            autocomplete: {
                type: String,
                default: 'off',
                required: false
            },
            preventSAPSpecialChars: {
                type: Boolean,
                default: true,
                required: false
            },
            maxlength: {
                default: 0,
                required: false
            }
        },
        data() {
            return {
                innerValue: ''
            }
        },
        computed: {
            inputType() {
                return isNullOrUndefined(this.$attrs.type) ? 'text' : this.$attrs.type;
            },
            computedStyle() {
                return this.flex != '1' ? { flex: this.flex } : null;
            },
            isDisabled() {
                return this.$attrs.disabled == true; //!isNullOrUndefined(this.$attrs.disabled);
            },
            inputListeners() {
                var vm = this
                // `Object.assign` merges objects together to form a new object
                return Object.assign({},
                    // We add all the listeners from the parent
                    this.$listeners,
                    // Then we can add custom listeners or override the
                    // behavior of some listeners.
                    {
                        // This ensures that the component works with v-model
                        input: function (event) {
                            vm.$emit('input', event.target.value)
                        },
                        change: function (event) {
                            vm.$emit('change', event.target.value)
                        }
                    }
                )
            },
            computedVid() {
                if (this.vid !== '')
                    return this.vid;
                else
                    return this.$id('vid');
            }
        },
        methods: {
            checkSapCharacters(evt) {
                if (this.preventSAPSpecialChars && !allowCharacter(evt.key)) {
                    evt.preventDefault();
                }                
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(newVal) {
                    this.innerValue = newVal;
                }
            }
        },
        components: {
            ValidationProvider
        }
    }
</script>